/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentType } from '../../models/document-type';
import { GetDocumentResponse } from '../../models/get-document-response';

export interface GetDummies$Params {
  dummyType: DocumentType;
}

export function getDummies(http: HttpClient, rootUrl: string, params: GetDummies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GetDocumentResponse>>> {
  const rb = new RequestBuilder(rootUrl, getDummies.PATH, 'get');
  if (params) {
    rb.path('dummyType', params.dummyType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GetDocumentResponse>>;
    })
  );
}

getDummies.PATH = '/api/documents/dummies/{dummyType}';
